import apiClient from './apiClient';

const API_URL = '/archivos';



// Subir archivo - CORREGIDO
export const subirArchivo = async (idTramite, archivo) => {
    try {
        console.log("📤 Iniciando subida de archivo:", {
            idTramite,
            nombre: archivo.name,
            tamaño: archivo.size,
            tipo: archivo.type
        });

        const formData = new FormData();
        formData.append('archivo', archivo);
        // NO enviar idTramite como campo separado, va en la URL

        // 🔥 CORRECCIÓN: Usar el endpoint correcto
        const response = await apiClient.post(`${API_URL}/${idTramite}/subir`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            timeout: 120000,
        });

        console.log("✅ Archivo subido exitosamente:", response.data);
        return response.data;

    } catch (error) {
        console.error("❌ Error detallado en subirArchivo:", {
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
            config: error.config?.url
        });

        let errorMessage = 'Error al subir el archivo';
        if (error.response?.data) {
            errorMessage = typeof error.response.data === 'string'
                ? error.response.data
                : error.response.data.message || JSON.stringify(error.response.data);
        } else if (error.message) {
            errorMessage = error.message;
        }

        throw new Error(errorMessage);
    }
};

// Obtener archivos por trámite
export const obtenerArchivosPorTramite = async (idTramite) => {
    try {
        console.log("📥 Obteniendo archivos para trámite:", idTramite);
        const response = await apiClient.get(`${API_URL}/tramite/${idTramite}`);
        console.log("📁 Archivos obtenidos:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error obteniendo archivos:", error);
        if (error.response?.status === 404) {
            return [];
        }
        throw error;
    }
};

// Descargar archivo
export const descargarArchivo = async (idArchivo) => {
    try {
        console.log("📥 Descargando archivo:", idArchivo);
        const response = await apiClient.get(`${API_URL}/${idArchivo}/descargar`, {
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error("❌ Error descargando archivo:", error);
        throw error;
    }
};

// Eliminar archivo
export const eliminarArchivo = async (idArchivo) => {
    try {
        console.log("🗑️ [SERVICE] Eliminando archivo con ID:", idArchivo);
        console.log("🌐 [SERVICE] URL:", `${API_URL}/${idArchivo}`);

        const response = await apiClient.delete(`${API_URL}/${idArchivo}`);

        console.log("✅ [SERVICE] Archivo eliminado exitosamente:", response.data);
        return response.data;

    } catch (error) {
        console.error("❌ [SERVICE] Error eliminando archivo:", {
            idArchivo: idArchivo,
            status: error.response?.status,
            data: error.response?.data,
            message: error.message
        });
        throw error;
    }
};